module.exports = __webpack_public_path__ + "img/person_icon.92d78cd6.png";